export enum DialogConfirmType {
    CONFIRM_CLOSE,
    CONFIRM_DELETE_ADDRESS,
    CONFIRM_AVAILABLE_BUDGET,
    CONFIRM_CANCEL_SHARE_BUDGET,
    CONFIRM_CONTINUE_BOOKER_BUDGET,
    CONFIRM_CANCEL_SHARE_BUDGET_FROM_USER,
    CONFIRM_CONTINUE_BOOKING,
    CONFIRM_CONTINUE_WITHOUT_PROMOTION_CODE,
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-confirm/dialog-confirm.model.ts